import React, { useMemo } from "react";
import { Card, CardContent, Grid, Stack, Typography } from "@mui/material";

function formatPct(v) {
  if (v == null || Number.isNaN(Number(v))) return "—";
  const n = Number(v);
  return `${Math.round(n * 1000) / 10}%`;
}

export default function CampaignMetricsHeader({ campaign, metrics }) {
  const leads = metrics?.leads ?? 0;
  const conversions = metrics?.conversions ?? 0;
  const revenue = metrics?.revenue ?? 0;

  const conversionRate = useMemo(() => {
    if (!leads) return null;
    return conversions / leads;
  }, [conversions, leads]);

  const leadSource = metrics?.leadSource ?? metrics?.source ?? campaign?.channel ?? (campaign?.channels?.[0] || "—");

  return (
    <Card variant="outlined" sx={{ mb: 2 }}>
      <CardContent>
        <Stack direction={{ xs: "column", md: "row" }} spacing={2} alignItems={{ md: "center" }} justifyContent="space-between" mb={2}>
          <div>
            <Typography fontWeight={900}>Dashboard da campanha</Typography>
            <Typography variant="body2" color="text.secondary">
              Resultado + saúde do funil no topo.
            </Typography>
          </div>
          <Typography variant="body2" color="text.secondary">
            Origem dos leads: <strong>{String(leadSource || "—")}</strong>
          </Typography>
        </Stack>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <Card variant="outlined">
              <CardContent>
                <Typography variant="body2" color="text.secondary">
                  Leads totais
                </Typography>
                <Typography variant="h5" fontWeight={900}>
                  {leads}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card variant="outlined">
              <CardContent>
                <Typography variant="body2" color="text.secondary">
                  Conversões
                </Typography>
                <Typography variant="h5" fontWeight={900}>
                  {conversions}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card variant="outlined">
              <CardContent>
                <Typography variant="body2" color="text.secondary">
                  Receita
                </Typography>
                <Typography variant="h5" fontWeight={900}>
                  {revenue}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card variant="outlined">
              <CardContent>
                <Typography variant="body2" color="text.secondary">
                  Taxa de conversão
                </Typography>
                <Typography variant="h5" fontWeight={900}>
                  {formatPct(conversionRate)}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

